// AcceptServiceOrderReqWithoutCustPage.js
import React, { useEffect, useState } from "react";
import { FaCheck } from "react-icons/fa";
import "../../../invite.css";

const AcceptServiceOrderReqWithoutCustPage = () => {
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(null);
  const BASE_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const mainId = queryParams.get("pvid");
    const custid = queryParams.get("uid");

    const handleAccept = async () => {
      if (!mainId) {
        console.warn("❌ Missing projAddItemId in query string");
        setSuccess(false);
        setLoading(false);
        return;
      }
      if (!custid) {
        console.warn("❌ Missing projAddItemId in query string");
        setSuccess(false);
        setLoading(false);
        return;
      }

      try {

        // 🔹 Step 2: Send approval request with customerID
        try {
          const response = await fetch(`${BASE_URL}/WorkOrderRequest/Approve_WorkOrderRequest_By_Customer`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              workOrderRequestID: parseInt(mainId),
              customerID: parseInt(custid),
              statusID: 1, // --> 1 = Accept
            }),
          });

          if (!response.ok) throw new Error(`Approval failed with status ${response.status}`);
          setSuccess(true);
        } catch (err) {
          throw new Error("Failed to approve Additional Item: " + err.message);
        }
      } catch (error) {
        console.error("❌ Error in handleAccept:", error);
        setSuccess(false);
      } finally {
        setLoading(false);
      }
    };

    handleAccept();
  }, [BASE_URL]);

  if (loading) {
    return (
      <div className="center-screen">
        <div className="loader-container" aria-live="polite">
          <img
            src="/Montdor_1.png"
            alt="Company Logo"
            className="company-logo"
            onError={(e) => (e.target.style.display = "none")}
          />
          <div className="spinner"></div>
          <p className="loader-text">Processing your request...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="center-screen" style={{ backgroundColor: "#2c2139" }}>
      <div className="card-box">
        {success ? (
          <>
            <div className="icon">
              <FaCheck size={48} color="#a0b750" />
            </div>
            <h2 className="card-title">Approved</h2>
            <p className="card-msg">Additional Item has been Approved.</p>
          </>
        ) : (
          <>
            <div className="icon">
              <FaCheck size={48} color="#888" />
            </div>
            <h2 className="card-title">Error</h2>
            <p className="card-msg">Unable to approve Additional Item.</p>
          </>
        )}
      </div>
    </div>
  );
};

export default AcceptServiceOrderReqWithoutCustPage;